import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CommonItemModule } from '@shared/core/components/commonItem';

import { TileForTransactionProductItemComponent } from './tile-for-transaction-product-item.shared.component';

@NgModule({
    declarations: [
        TileForTransactionProductItemComponent
    ],
    imports: [
        CommonModule,
        CommonItemModule,
    ],
    exports: [
        TileForTransactionProductItemComponent
    ],
    providers: [],
})
export class TileForTransactionProductItemModule { }
